export enum ApprovalViaGdms {
    YES = 'PAGE.GENERAL.YES.LBL',
    NO = 'PAGE.GENERAL.NO.LBL',
    NOT_APPLICABLE = 'PAGE.GENERAL.NOT_APPLICABLE.LBL'
}
